export enum StatusApp {
    Pendente = 0,
    Ativo = 1
}
